import React, { Component } from "react";
import { resolveWarrantyStatus, getLatestWarrantyExpireDate, addDaysToDate, calcWarrantyExpireDate, calcWarrantyMonthDiff } from "../../utils/warranty";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  alert,
  GET,
  PUT,
  Select,
  Modal,
  t,
  format_date,
  DatePicker,
  ActionIconButton,
  ACTION_ICONS,
  STICKY_ACTION_STYLE,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

export default class WarehouseAssetManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Filters
      filter_search: "",
      filter_customer: "",
      filter_status: "",
      filter_vendor_warranty: "false",

      // Data
      data: [],
      data_all: [],
      data_customer: [],
      data_finance: [],
      data_sale: [],
      data_part: [],
      data_branch: [],
      data_cwc: [],
      count: 0,

      // Modal State
      modal_view: false,
      modal_view_closing: false,
      modal_edit_mode: false, // false = view only, true = Vendor Warranty is editable
      modal_map: false, // แผนที่แบบดูอย่างเดียว (ปักหมุดไม่ได้ มีแต่ปุ่มปิด)
      currentPath: null,

      // --- Detail fields (read-only, mirrors admin/assets.js) ---
      uid: "",
      branch_id: "",
      asset_code: "",
      customer_id: "",
      finance_id: "",
      sale_id: "",
      part_id: "",
      serial_number: "",
      price: "",

      location_running_number: "",
      location_name: "",
      location_address: "",
      location_province: "",
      location_district: "",
      location_sub_district: "",
      location_zip_code: "",
      location_floor_room: "",
      latitude: "",
      longitude: "",
      location_remark: "",

      contract_name: "",
      contract_phone: "",
      contract_email: "",

      invoice_number: "",
      invoice_date: "",
      coi_date: "",

      customer_warranty: [{ customer_warranty_month: "", customer_warranty_expire_date: "", customer_warranty_renew_date: "", customer_warranty_renew_remark: "" }],
      customer_warranty_count: 0,
      customer_warranty_remark: "",
      cwc_attachments: [],

      // Editable section — Vendor Warranty (ประกันโรงงาน)
      company_warranty: [{ company_warranty_start_date: "", company_warranty_month: "", company_warranty_expire_date: "", company_warranty_renew_date: "", company_warranty_renew_remark: "" }],
      company_warranty_count: 0,
      company_warranty_remark: "",

      is_active: true,
      tags: [],
    };
  }

  async componentDidMount() {
    this.GetReferenceData();
    this.Get(1);
  }

  componentWillUnmount() {
    if (this.modalCloseTimer) clearTimeout(this.modalCloseTimer);
  }

  // --- API Functions (mirrors admin/assets.js Get()) ---

  // ข้อมูลอ้างอิงสำหรับ dropdown: โหลดครั้งเดียวตอนเข้าหน้า ไม่โหลดซ้ำทุกครั้งที่เปลี่ยนหน้า/ค้นหา
  GetReferenceData = async () => {
    let data_customer = [], data_finance = [], data_sale = [], data_part = [], data_branch = [], data_cwc = [];

    let [result_customer, result_finance, result_sale, result_part, result_branch, result_cwc] = await Promise.all([
      GET("admin/customers", { page_size: 10000, page: 0, data_search: "" }),
      GET("admin/finance-masters", { page_size: 10000, page: 0, data_search: "" }),
      GET("admin/sale-masters", { page_size: 10000, page: 0, data_search: "" }),
      // lite=true: backend ส่ง field หลัก + ชื่อ relation จากคอลัมน์ snapshot ไม่ join
      GET("warehouse/part-masters", { page_size: 10000, page: 0, data_search: "", lite: "true" }),
      GET("warehouse/branches", { page_size: 10000, page: 0, data_search: "" }),
      GET("admin/customer-warranty-conditions", { page_size: 10000, page: 0, data_search: "" }),
    ]);

    if (result_customer?.status) {
      data_customer = result_customer.data.map(e => ({ ...e, value: e.uid, label: e.customer_code + " " + (e.full_name_th || e.name) })) || [];
    }
    if (result_finance?.status) {
      data_finance = result_finance.data.map(e => ({ value: e.uid, label: e.finance_code + " " + e.finance_name_th })) || [];
    }
    if (result_sale?.status) {
      // พนักงานขาย / พนักงานดูแล: มีชื่อเล่นให้ต่อท้ายเป็น "รหัส ชื่อ (ชื่อเล่น)" ไม่มีก็แสดงรหัสกับชื่ออย่างเดียว (เหมือนหน้า asset ฝั่ง admin)
      data_sale = result_sale.data.map(e => ({
        value: e.uid,
        label: [e.sale_code, e.name_th, e.nickname?.trim() ? `(${e.nickname.trim()})` : ""].filter(Boolean).join(" "),
      })) || [];
    }
    if (result_part?.status) {
      data_part = result_part.data.map(e => ({ ...e, value: e.uid, label: e.part_number })) || [];
    }
    if (result_branch?.status) {
      data_branch = result_branch.data.map(e => ({ ...e, value: e.uid, label: e.name })) || [];
    }
    if (result_cwc?.status) {
      data_cwc = result_cwc.data.filter(e => e.is_active !== false).map(e => ({ value: e.uid, label: (e.code ? e.code + " " : "") + (e.name || "") })) || [];
    }

    this.setState({ data_customer, data_finance, data_sale, data_part, data_branch, data_cwc });
  };

  Get = async (page = 1) => {
    let data = [], count = 0, data_all = [];
    const { filter_search, filter_customer, filter_status, filter_vendor_warranty } = this.state;
    loading(true);

    let [result, result_all] = await Promise.all([
      GET("admin/assets", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        customer_id: filter_customer || "",
        is_active: filter_status || "",
        has_vendor_warranty: filter_vendor_warranty || "",
        type: "",
        uid: ""
      }),
      // kpi=true: ดึงครบทุกรายการตาม filter แต่เฉพาะ field ที่ใช้นับ KPI (เบากว่าดึงเต็มมาก)
      GET("admin/assets", {
        page: 0,
        kpi: "true",
        data_search: filter_search || "",
        customer_id: filter_customer || "",
        is_active: filter_status || "",
        has_vendor_warranty: filter_vendor_warranty || "",
        type: "",
        uid: ""
      }),
    ]);

    if (result?.status) {
      data = result.data || [];
      count = result.pagination?.count || 0;
    }
    if (result_all?.status) {
      data_all = result_all.data || [];
    }

    this.setState({ data, count, data_all });
    loading(false);
  };

  // --- Handlers ---

  closeModalWithAnimation = (modalKey) => {
    const closingKey = `${modalKey}_closing`;
    if (!this.state[modalKey] || this.state[closingKey]) return;
    if (this.modalCloseTimer) clearTimeout(this.modalCloseTimer);
    this.setState({ [closingKey]: true });
    this.modalCloseTimer = setTimeout(() => {
      this.setState({ [modalKey]: false, [closingKey]: false });
      this.modalCloseTimer = null;
    }, 220);
  };

  openModalDetail = async (item, editMode = false) => {
    loading(true);
    let result = await GET("admin/assets", { uid: item.uid });
    if (result.status === true) {
      let data = result.data;
      const normalizedWarranty = this.normalizeAssetWarrantyState(data);
      this.setState({
        modal_view: true,
        modal_view_closing: false,
        modal_edit_mode: editMode,
        ...data,
        ...normalizedWarranty,
        uid: data?.uid,
        branch_id: data?.branch?.uid || "",
        customer_id: data?.customer?.uid || "",
        finance_id: data?.finance?.uid || "",
        part_id: data?.part?.uid || "",
        sale_id: data?.sale?.uid || "",
        invoice_date: data?.invoice_date ? format_date(data?.invoice_date, "yyyy-mm-dd", "en") : "",
        coi_date: data?.coi_date ? format_date(data?.coi_date, "yyyy-mm-dd", "en") : "",
        cwc_attachments: (data?.customer_warranty_attachments || []).map((a) => ({
          uid: a.uid,
          url: a.file_path,
          name: a.file_name || a.file_path?.split("/").pop() || "",
          file_type: a.file_type,
          mime_type: a.mime_type,
          file_size: a.file_size,
        })),
      });
    }
    loading(false);
  };

  // --- Vendor Warranty helpers (mirrors admin/assets.js — generic by section, only "company" is editable here) ---

  normalizeWarrantyEntries = (entries, monthKey, expireKey) => {
    return (entries || []).filter(
      (item) => item && (String(item[monthKey] ?? "").trim() !== "" || String(item[expireKey] ?? "").trim() !== "")
    );
  };

  normalizeAssetWarrantyState = (data = {}) => {
    const customerWarranty = data?.customer_warranty?.map((item) => ({
      customer_warranty_month: item?.customer_warranty_month?.toString?.() || item?.customer_warranty_month || "",
      customer_warranty_expire_date: item?.customer_warranty_expire_date ? format_date(item.customer_warranty_expire_date, "yyyy-mm-dd", "en") : "",
      customer_warranty_renew_date: item?.customer_warranty_renew_date ? format_date(item.customer_warranty_renew_date, "yyyy-mm-dd", "en") : "",
      customer_warranty_renew_remark: item?.customer_warranty_renew_remark || "",
    })) || [];

    const companyWarranty = data?.company_warranty?.map((item) => ({
      company_warranty_start_date: item?.company_warranty_start_date ? format_date(item.company_warranty_start_date, "yyyy-mm-dd", "en") : "",
      company_warranty_month: item?.company_warranty_month?.toString?.() || item?.company_warranty_month || "",
      company_warranty_expire_date: item?.company_warranty_expire_date ? format_date(item.company_warranty_expire_date, "yyyy-mm-dd", "en") : "",
      company_warranty_renew_date: item?.company_warranty_renew_date ? format_date(item.company_warranty_renew_date, "yyyy-mm-dd", "en") : "",
      company_warranty_renew_remark: item?.company_warranty_renew_remark || "",
    })) || [];

    const normalizedCustomerWarranty = customerWarranty.length ? customerWarranty : [{ customer_warranty_month: "", customer_warranty_expire_date: "" }];
    const normalizedCompanyWarranty = companyWarranty.length ? companyWarranty : [{ company_warranty_start_date: "", company_warranty_month: "", company_warranty_expire_date: "" }];

    return {
      customer_warranty: normalizedCustomerWarranty,
      customer_warranty_count: normalizedCustomerWarranty.filter(
        (item) => String(item.customer_warranty_month ?? "").trim() !== "" || String(item.customer_warranty_expire_date ?? "").trim() !== ""
      ).length,
      company_warranty: normalizedCompanyWarranty,
      company_warranty_count: normalizedCompanyWarranty.filter(
        (item) => String(item.company_warranty_month ?? "").trim() !== "" || String(item.company_warranty_expire_date ?? "").trim() !== ""
      ).length,
    };
  };

  // วันหมดประกันที่ใช้แสดง/ตัดสินสถานะ = รอบที่ครอบวันนี้ ถ้าไม่มีรอบไหนครอบ = รอบล่าสุดที่เริ่มไปแล้ว
  // (เช็ควันเริ่มรอบด้วย ไม่ใช่วันหมดที่ไกลสุด - ดู utils/warranty.js) รอบที่ 1 เริ่มที่ coi_date ในฟอร์ม
  getLatestWarrantyExpireDate = (warrantyList, monthKey, expireKey, fallback = "", coiDate = this.state.coi_date) => {
    const section = String(expireKey).startsWith("company") ? "company" : "customer";
    const normalizedList = this.normalizeWarrantyEntries(warrantyList, monthKey, expireKey);
    return resolveWarrantyStatus({ coi_date: coiDate, [`${section}_warranty`]: normalizedList, [expireKey]: fallback }, section).expireDate;
  };

  // ช่องประกันผู้จำหน่ายใน modal: วันที่แสดง = วันหมดของรอบล่าสุด (ให้ตรงกับตารางรายการ)
  // ส่วนสถานะ ✓/✗ ยังดูจากวันนี้ (รอบที่ครอบวันนี้) ตาม resolveWarrantyStatus
  getVendorWarrantyDisplay = (warrantyList, fallback = "", coiDate = this.state.coi_date) => {
    const expireKey = "company_warranty_expire_date";
    const asset = { coi_date: coiDate, company_warranty: this.normalizeWarrantyEntries(warrantyList, "company_warranty_month", expireKey), [expireKey]: fallback };
    return { date: getLatestWarrantyExpireDate(asset, "company"), expired: resolveWarrantyStatus(asset, "company").expired };
  };

  // วันหมดประกันของเครื่องในตาราง list = รอบที่ครอบวันนี้ หรือรอบล่าสุดที่เริ่มไปแล้ว (utils/warranty.js)
  getAssetLatestWarrantyExpireDate = (item, section) => resolveWarrantyStatus(item, section).expireDate;

  isWarrantyExpired = (expireDate) => {
    const raw = String(expireDate || "").trim();
    if (!raw) return true;
    const parsed = new Date(raw.split("T")[0]);
    if (isNaN(parsed.getTime())) return true;
    parsed.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return parsed < today;
  };

  // ครั้งที่ 1: ใช้ "วันเริ่มประกัน" ของตัวเอง (ถ้ามี) ไม่งั้นใช้วันที่ EOI (coi_date)
  // สำหรับครั้งที่ 2 เป็นต้นไป ใช้ "วันที่ต่อประกัน" ของตัวเองเป็นฐาน (ถ้ามี)
  // ถ้ายังไม่ได้ระบุ (ข้อมูลเก่าก่อนมี field นี้) ให้ใช้วันหมดประกันของครั้งก่อนหน้าแทน
  getWarrantyBaseDate = (warrantyList, index, expireKey, renewKey, coiDate, startKey) => {
    if (index === 0) return (startKey && warrantyList?.[0]?.[startKey]) || coiDate || "";
    return warrantyList?.[index]?.[renewKey] || addDaysToDate(warrantyList?.[index - 1]?.[expireKey], 1);
  };

  formatUserActivity = (name, dateValue) => {
    if (!name) return "-";
    const datePart = dateValue ? `${format_date(dateValue, "dd/mm/yyyy hh:mm", "th")} ${t("unit_oclock")}` : "";
    return datePart ? `${name} (${datePart})` : name;
  };

  // วันหมดประกัน = วันเริ่ม + N เดือน - 1 วัน (วันเริ่มนับเป็นวันแรก) ดู utils/warranty.js
  addMonthsToDate = (dateString, months) => {
    if (!dateString || months === "" || months === null || months === undefined) return "";
    return calcWarrantyExpireDate(dateString, months);
  };

  // จำนวนเดือนจากวันเริ่มถึงวันหมดที่ผู้ใช้แก้เอง (นับรวมวันหมด)
  getMonthDiff = (startDateString, endDateString) => calcWarrantyMonthDiff(startDateString, endDateString);

  recalculateWarrantyList = (list, monthKey, expireKey, renewKey, coiDate, startKey) => {
    return (list || []).reduce((acc, item, index) => {
      const prevExpire = index === 0 ? ((startKey && item?.[startKey]) || coiDate) : (acc[index - 1]?.[expireKey] || "");
      const renewDate = index === 0 ? "" : (item?.[renewKey] || addDaysToDate(prevExpire, 1));
      const baseDate = index === 0 ? prevExpire : renewDate;
      acc.push({
        ...item,
        [renewKey]: renewDate,
        [expireKey]: baseDate && item?.[monthKey] !== "" && item?.[monthKey] !== null ? this.addMonthsToDate(baseDate, item[monthKey]) : "",
      });
      return acc;
    }, []);
  };

  updateWarrantyMonthValue = (section, index, value) => {
    if (String(value).includes("-")) {
      return;
    }

    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, renewKey, this.state.coi_date, `${section}_warranty_start_date`);

    warrantyList[index] = {
      ...warrantyList[index],
      [monthKey]: value,
      [expireKey]: baseDate && value !== "" ? this.addMonthsToDate(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(warrantyList, monthKey, expireKey).length,
    });
  };

  updateWarrantyExpireValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, renewKey, this.state.coi_date, `${section}_warranty_start_date`);

    warrantyList[index] = {
      ...warrantyList[index],
      [expireKey]: value,
      [monthKey]: baseDate && value ? this.getMonthDiff(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(warrantyList, monthKey, expireKey).length,
    });
  };

  // วันเริ่มประกัน ครั้งที่ 1: ว่าง = ใช้วันที่ EOI (coi_date) ระบุเองได้เมื่อประกันผู้จำหน่ายไม่ได้เริ่มที่ EOI
  // เปลี่ยนแล้วคำนวณวันหมดประกันของทุกช่วงใหม่ (ช่วงถัดไปที่ไม่มี renew_date จะขยับตามด้วย)
  updateWarrantyStartDateValue = (section, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const startKey = `${section}_warranty_start_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    if (!warrantyList.length) return;

    warrantyList[0] = { ...warrantyList[0], [startKey]: value };
    const nextList = this.recalculateWarrantyList(warrantyList, monthKey, expireKey, renewKey, this.state.coi_date, startKey);

    this.setState({
      [warrantyKey]: nextList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(nextList, monthKey, expireKey).length,
    });
  };

  // วันที่ต่อประกัน ครั้งที่ 2 เป็นต้นไป: default มาจากวันหมดประกันของครั้งก่อนหน้า แต่แก้ไขได้เอง
  updateWarrantyRenewDateValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const currentMonth = warrantyList[index]?.[monthKey];

    warrantyList[index] = {
      ...warrantyList[index],
      [renewKey]: value,
      [expireKey]: value && currentMonth !== "" && currentMonth !== null && currentMonth !== undefined ? this.addMonthsToDate(value, currentMonth) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(warrantyList, monthKey, expireKey).length,
    });
  };

  // หมายเหตุของการต่อประกันแต่ละครั้ง (ครั้งที่ 2 เป็นต้นไป)
  updateWarrantyRenewRemarkValue = (section, index, value) => {
    const remarkKey = `${section}_warranty_renew_remark`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    warrantyList[index] = { ...warrantyList[index], [remarkKey]: value };
    this.setState({ [warrantyKey]: warrantyList });
  };

  addWarrantyEntry = (section) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const remarkKey = `${section}_warranty_renew_remark`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const latestEntry = warrantyList[warrantyList.length - 1];

    if (String(latestEntry?.[monthKey] ?? "").trim() === "" || Number(latestEntry?.[monthKey]) < 0 || !latestEntry?.[expireKey]) {
      alert("", "warning", t("warning"), t("validate_warranty_latest_entry_complete"));
      return;
    }

    warrantyList.push({ [monthKey]: "", [expireKey]: "", [renewKey]: addDaysToDate(latestEntry?.[expireKey], 1), [remarkKey]: "" });
    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(warrantyList, monthKey, expireKey).length,
    });
  };

  deleteWarrantyEntry = async (section, index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;

    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const renewKey = `${section}_warranty_renew_date`;
    const warrantyKey = `${section}_warranty`;
    const currentList = [...(this.state[warrantyKey] || [])];
    const filteredList = currentList.filter((_, itemIndex) => itemIndex !== index);
    const nextList = filteredList.length
      ? this.recalculateWarrantyList(filteredList, monthKey, expireKey, renewKey, this.state.coi_date, `${section}_warranty_start_date`)
      : [{ [monthKey]: "", [expireKey]: "" }];

    this.setState({
      [warrantyKey]: nextList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(nextList, monthKey, expireKey).length,
    });
  };

  isLatestWarrantyEntryComplete = (warrantyList, monthKey, expireKey) => {
    const latestEntry = warrantyList?.[warrantyList.length - 1];
    return (
      String(latestEntry?.[monthKey] ?? "").trim() !== "" &&
      Number(latestEntry?.[monthKey]) >= 0 &&
      !!latestEntry?.[expireKey]
    );
  };

  SaveVendorWarranty = async () => {
    const { uid, company_warranty, company_warranty_remark } = this.state;
    const normalized = this.normalizeWarrantyEntries(company_warranty, "company_warranty_month", "company_warranty_expire_date");

    if (normalized.length && !this.isLatestWarrantyEntryComplete(normalized, "company_warranty_month", "company_warranty_expire_date")) {
      alert("", "warning", t("warning"), t("validate_asset_vendor_warranty_complete"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      let body = {
        company_warranty: normalized.map((item, index) => ({
          company_warranty_start_date: index === 0 ? item.company_warranty_start_date || null : null,
          company_warranty_month: Number(item.company_warranty_month) || 0,
          company_warranty_expire_date: item.company_warranty_expire_date || null,
          company_warranty_renew_date: index > 0 ? item.company_warranty_renew_date || null : null,
          company_warranty_renew_remark: index > 0 ? item.company_warranty_renew_remark || "" : "",
        })),
        company_warranty_count: normalized.length,
        company_warranty_remark,
      };
      let result = await PUT(`admin/assets/${uid}/vendor-warranty`, body);
      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.closeModalWithAnimation("modal_view");
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  renderModalAnimationStyle = () => (
    <style>{`
      .asset-modal-backdrop { animation: assetBackdropFadeIn 180ms ease-out; }
      .asset-modal-dialog { animation: assetModalLiftIn 220ms ease-out; transform-origin: center center; }
      .asset-modal-backdrop.is-closing { animation: assetBackdropFadeOut 220ms ease-in forwards; }
      .asset-modal-dialog.is-closing { animation: assetModalLiftOut 220ms ease-in forwards; }
      @keyframes assetBackdropFadeIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes assetModalLiftIn { from { opacity: 0; transform: translateY(14px) scale(0.985); } to { opacity: 1; transform: translateY(0) scale(1); } }
      @keyframes assetBackdropFadeOut { from { opacity: 1; } to { opacity: 0; } }
      @keyframes assetModalLiftOut { from { opacity: 1; transform: translateY(0) scale(1); } to { opacity: 0; transform: translateY(10px) scale(0.99); } }
      @media (prefers-reduced-motion: reduce) {
        .asset-modal-backdrop, .asset-modal-dialog { animation: none !important; }
      }
    `}</style>
  );

  // --- Detail Modal (mirrors admin/assets.js renderDetailModal — identical read-only fields, except Vendor Warranty is editable) ---
  renderDetailModal = () => {
    const {
      modal_view, modal_view_closing, modal_edit_mode, data_customer, data_finance, data_sale, data_part, data_branch,
      asset_code, branch_id, customer_id, finance_id, sale_id, part_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, location_floor_room,
      latitude, longitude, location_remark,
      contract_name, contract_phone, contract_email,
      invoice_number, invoice_date, coi_date,
      customer_warranty, customer_warranty_count, customer_warranty_remark,
      company_warranty, company_warranty_count, company_warranty_remark,
      is_active, tags, cwc_attachments,
      created_by, created_at, updated_by, updated_at,
    } = this.state;

    const detailCustomerWarranty = this.normalizeWarrantyEntries(customer_warranty, "customer_warranty_month", "customer_warranty_expire_date");
    const detailCompanyWarranty = this.normalizeWarrantyEntries(company_warranty, "company_warranty_month", "company_warranty_expire_date");
    const latestCustomerWarrantyExpireDate = this.getLatestWarrantyExpireDate(customer_warranty, "customer_warranty_month", "customer_warranty_expire_date");
    const vendorWarrantyDisplay = this.getVendorWarrantyDisplay(company_warranty);
    const latestCompanyWarrantyExpireDate = vendorWarrantyDisplay.date;
    const isLatestCustomerWarrantyComplete = this.isLatestWarrantyEntryComplete(customer_warranty, "customer_warranty_month", "customer_warranty_expire_date");
    const isLatestCompanyWarrantyComplete = this.isLatestWarrantyEntryComplete(company_warranty, "company_warranty_month", "company_warranty_expire_date");

    if (!modal_view) return null;

    const SectionHeader = ({ num, title, enTitle, icon }) => (
      <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2 mt-4">
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-2 text-12 shadow-sm">{num}</div>
          <h6 className="fw-bold mb-0 text-dark d-flex align-items-center">
            {icon && <span className="icon text-secondary me-2">{icon}</span>}
            {title}
          </h6>
        </div>
        <div className="text-muted text-12 text-uppercase">{enTitle}</div>
      </div>
    );

    const ViewBox = ({ value }) => (
      <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "34px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {value || "-"}
      </div>
    );

    return (
        <div className={`modal fade show d-block asset-modal-backdrop${modal_view_closing ? " is-closing" : ""}`} style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
            {this.renderModalAnimationStyle()}
            <div className={`modal-dialog modal-dialog-centered modal-fullscreen p-2 p-md-4 asset-modal-dialog${modal_view_closing ? " is-closing" : ""}`}>
                <div className="modal-content border-0 rounded-4 shadow bg-light overflow-hidden d-flex flex-column" style={{ maxHeight: "100%" }}>
                    <button
                        type="button"
                        onClick={() => this.closeModalWithAnimation("modal_view")}
                        aria-label="Close"
                        className="d-flex align-items-center justify-content-center border-0 rounded-circle position-absolute"
                        style={{
                            top: "12px",
                            right: "12px",
                            width: "32px",
                            height: "32px",
                            zIndex: 5,
                            backgroundColor: "#fff",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
                            color: "#dc3545",
                            fontSize: "16px",
                            cursor: "pointer",
                        }}
                    >
                        <span className="icon">{""}</span>
                    </button>

                    <div className="modal-header border-bottom px-4 py-3 bg-white d-flex justify-content-between align-items-center">
                        <div>
                            <div className="text-primary text-12 mb-1 fw-bold">
                                {t("asset_management")} <span className="text-secondary mx-1">&gt;</span> <span className="text-dark">{t("label_asset_detail")}</span>
                            </div>
                            <h4 className="fw-bold mb-1 d-flex align-items-center text-dark">
                                <span className="icon me-2 text-secondary">{""}</span> {t("label_asset_detail")}
                            </h4>
                            <div className="text-muted text-12">{modal_edit_mode ? t("note_edit_vendor_warranty_only") : t("subtitle_asset_detail")}</div>
                        </div>
                    </div>

                    <div className="modal-body p-2 p-md-4 bg-light overflow-auto">
                        <div className="card border-0 shadow-sm rounded-4 p-2 p-md-4 mb-4 bg-white">
                            <div className="d-flex justify-content-between align-items-center position-relative w-100 px-3">
                                <div className="position-absolute top-50 start-0 w-100 bg-light" style={{ height: "2px", zIndex: 0 }}></div>
                                {[
                                    { num: 1, label: t("section_customer_info"), en: "Customer", active: !!customer_id },
                                    { num: 2, label: t("step_item_info"), en: "Item / Asset", active: !!(part_id && serial_number) },
                                    {
                                        num: 3,
                                        label: t("installation_location"),
                                        en: "Location",
                                        active: !!(location_name && location_address && location_province && location_district && location_sub_district && location_zip_code),
                                    },
                                    { num: 4, label: t("section_invoice_info"), en: "Invoice", active: !!(invoice_number && invoice_date && coi_date) },
                                    {
                                        num: 5,
                                        label: t("step_warranty_info"),
                                        en: "Warranty",
                                        active: customer_warranty_count > 0 && isLatestCustomerWarrantyComplete && company_warranty_count > 0 && isLatestCompanyWarrantyComplete,
                                    },
                                ].map((step, idx) => (
                                    <div key={idx} className="d-flex flex-column align-items-center position-relative bg-white px-2" style={{ zIndex: 1 }}>
                                        <div
                                            className={`wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center fw-bold text-12 mb-2 ${
                                                step.active ? "bg-primary text-white" : "bg-light text-secondary border"
                                            }`}
                                        >
                                            {step.num}
                                        </div>
                                        <div className={`fw-bold text-12 ${step.active ? "text-dark" : "text-secondary"}`}>{step.label}</div>
                                        {/* <div className="text-muted text-12">{step.en}</div> */}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-lg-8 col-xl-9">
                                <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                                    <SectionHeader num="1" title={t("section_customer_info")} icon={""} />
                                    <div className="row g-3 mb-3 mb-md-4">
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_branch")}</label>
                                            <ViewBox value={data_branch?.find((e) => e.value === branch_id)?.label} />
                                        </div>
                                        <div className="col-md-8">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_customer")}</label>
                                            <ViewBox value={data_customer?.find((e) => e.value === customer_id)?.full_name_th || data_customer?.find((e) => e.value === customer_id)?.label} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_finance")}</label>
                                            <ViewBox value={data_finance?.find((e) => e.value === finance_id)?.label || "-"} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_salesperson")}</label>
                                            <ViewBox value={data_sale?.find((e) => e.value === sale_id)?.label || "-"} />
                                        </div>
                                    </div>

                                    <SectionHeader num="2" title={t("section_item_info")} icon={""} />
                                    <div className="row g-3 mb-3 mb-md-4">
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_item_id")}</label>
                                            <ViewBox value={data_part?.find((e) => e.value === part_id)?.label || part_id} />
                                        </div>
                                        <div className="col-md-8">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_product_name")}</label>
                                            <ViewBox value={data_part?.find((e) => e.value === part_id)?.name} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_brand")}</label>
                                            <ViewBox value={data_part?.find((e) => e.value === part_id)?.brand?.name} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_model")}</label>
                                            <ViewBox value={data_part?.find((e) => e.value === part_id)?.modal?.name} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_category")}</label>
                                            <ViewBox value={data_part?.find((e) => e.value === part_id)?.part_category?.name} />
                                        </div>

                                        <div className="col-12 text-primary fw-bold text-12 mt-3">
                                            <span className="icon me-1">{""}</span> {t("heading_machine_details")}
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_serial_no")}</label>
                                            <ViewBox value={serial_number} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_machine_price")}</label>
                                            <ViewBox value={price ? `${Number(price).toLocaleString()} ${t("baht")}` : "-"} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_status")}</label>
                                            <div
                                                className={`form-control text-12 fw-bold ${
                                                    is_active === "true" || is_active === true ? "bg-success-light text-success" : "bg-secondary-light text-secondary"
                                                }`}
                                            >
                                                {is_active === "true" || is_active === true ? t("option_active_status") : t("option_inactive_status")}
                                            </div>
                                        </div>
                                    </div>

                                    <SectionHeader num="3" title={t("installation_location")} icon={""} />
                                    <div className="row g-3 mx-0 mb-3 mb-md-4">
                                        <div className="col-md-6">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_location_id")}</label>
                                            <ViewBox value={location_running_number} />
                                        </div>
                                        <div className="col-md-6"></div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_location_name")}</label>
                                            <ViewBox value={location_name} />
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_address")}</label>
                                            <ViewBox value={location_address} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("province")}</label>
                                            <ViewBox value={location_province} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_district")}</label>
                                            <ViewBox value={location_district} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_sub_district")}</label>
                                            <ViewBox value={location_sub_district} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("postal_code")}</label>
                                            <ViewBox value={location_zip_code} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_floor_room")}</label>
                                            <ViewBox value={location_floor_room} />
                                        </div>
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_latitude")}</label>
                                            <ViewBox value={latitude} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_longitude")}</label>
                                            <ViewBox value={longitude} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_pin_from_map")}</label>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary w-100 fw-bold text-12 d-flex align-items-center justify-content-center bg-primary-light"
                                                onClick={() => {
                                                    // ฝั่ง warehouse ดูแผนที่ได้อย่างเดียว ไม่ให้แก้ตำแหน่ง
                                                    this.setState({ modal_map: true, currentPath: latitude && longitude ? { lat: Number(latitude), lng: Number(longitude) } : null });
                                                }}
                                            >
                                                <span className="icon me-2">{"\uf279"}</span> {t("btn_pin_location")}
                                            </button>
                                        </div>

                                        <div className="col-12 text-primary fw-bold text-12 mt-3">
                                            <span className="icon me-1 text-info">{""}</span> {t("heading_location_contact")}
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_contact_name")}</label>
                                            <ViewBox value={contract_name} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("phone_number")}</label>
                                            <ViewBox value={contract_phone} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("email")}</label>
                                            <ViewBox value={contract_email} />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_location_remark")}</label>
                                            <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                                                {location_remark || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    <SectionHeader num="4" title={t("section_invoice_info")} icon={""} />
                                    <div className="row g-3 mb-3 mb-md-4">
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_no")}</label>
                                            <ViewBox value={invoice_number} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_date")}</label>
                                            <ViewBox value={invoice_date ? format_date(invoice_date, "dd/mm/yyyy", "th") : "-"} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("eoi_date")}</label>
                                            <ViewBox value={coi_date ? format_date(coi_date, "dd/mm/yyyy", "th") : "-"} />
                                        </div>
                                    </div>

                                    <SectionHeader num="5" title={t("section_warranty_info")} icon={""} />
                                    <div className="row g-3">
                                        <div className="col-12 d-flex justify-content-between align-items-center text-primary fw-bold text-12 mt-2">
                                            <div>
                                                <span className="icon me-1 text-primary">{""}</span> {t("warranty_customer")}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_remark")}</label>
                                            <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                                                {customer_warranty_remark || "-"}
                                            </div>
                                        </div>

                                        {(detailCustomerWarranty.length ? detailCustomerWarranty : [{ customer_warranty_month: "-", customer_warranty_expire_date: "" }]).map((item, index) => (
                                            <div key={`detail-customer-warranty-${index}`} className="col-12">
                                                <div className="card rounded-4 p-3 bg-white" style={{ outline: "1px solid #dddde0" }}>
                                                    <div className="text-primary fw-bold text-12 mb-3">
                                                        {t("customer_warranty_period_no")} {index + 1}
                                                    </div>
                                                    <div className="row g-3">
                                                        {index > 0 && (
                                                            <div className="col-md-4">
                                                                <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_date")}</label>
                                                                <ViewBox value={item.customer_warranty_renew_date ? format_date(item.customer_warranty_renew_date, "dd/mm/yyyy", "th") : "-"} />
                                                            </div>
                                                        )}
                                                        <div className="col-md-4">
                                                            <label className="form-label text-secondary fw-bold text-12">
                                                                {t("label_customer_warranty_ext")} ({t("unit_month")})
                                                            </label>
                                                            <ViewBox value={item.customer_warranty_month} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_end")}</label>
                                                            <ViewBox value={item.customer_warranty_expire_date ? format_date(item.customer_warranty_expire_date, "dd/mm/yyyy", "th") : "-"} />
                                                        </div>
                                                        {index > 0 && (
                                                            <div className="col-12">
                                                                <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_remark")}</label>
                                                                <ViewBox value={item.customer_warranty_renew_remark || "-"} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="col-md-4">
                                            <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_claim_count")}</label>
                                            <ViewBox value={customer_warranty_count} />
                                        </div>

                                        {cwc_attachments && cwc_attachments.length > 0 && (
                                            <div className="col-12">
                                                <label className="form-label text-secondary fw-bold text-12">
                                                    <span className="icon me-1">{""}</span> {t("label_attachment_view")}
                                                </label>
                                                <div className="d-flex flex-wrap gap-2 mt-1">
                                                    {cwc_attachments.map((file, i) => {
                                                        const isImage = (file.file_type || "").startsWith("image") || /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(file.url || "");
                                                        return (
                                                            <a
                                                                key={i}
                                                                href={file.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                download={file.name || undefined}
                                                                className="d-flex flex-column align-items-center text-decoration-none border rounded-3 bg-white p-2 shadow-sm"
                                                                style={{ width: 80, minHeight: 80, cursor: "pointer" }}
                                                                title={file.name}
                                                            >
                                                                {isImage ? (
                                                                    <img src={file.url} alt={file.name} style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 6 }} />
                                                                ) : (
                                                                    <div className="d-flex align-items-center justify-content-center text-secondary" style={{ width: 56, height: 56, fontSize: 28 }}>
                                                                        <span className="icon">{""}</span>
                                                                    </div>
                                                                )}
                                                                <div
                                                                    className="text-10 text-muted mt-1 text-center"
                                                                    style={{ wordBreak: "break-all", maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                                                >
                                                                    {file.name}
                                                                </div>
                                                            </a>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                        <div className="col-12 d-flex justify-content-between align-items-center text-success fw-bold text-12 mt-4">
                                            <div>
                                                <span className="icon me-1 text-success">{""}</span> {t("warranty_vendor")}
                                            </div>
                                        </div>
                                        <div className="col-12 d-flex justify-content-center">
                                            {modal_edit_mode ? (
                                                <button type="button" className="btn btn-outline-success btn-sm fw-bold w-100" onClick={() => this.addWarrantyEntry("company")}>
                                                    <span className="icon me-1">{""}</span> {t("add_asset_customer_warranty")}
                                                </button>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        {modal_edit_mode ? (
                                            <>
                                                {company_warranty.map((item, index) => {
                                                    const isLatest = index === company_warranty.length - 1;
                                                    const isRenewal = index > 0;
                                                    const baseDate = this.getWarrantyBaseDate(company_warranty, index, "company_warranty_expire_date", "company_warranty_renew_date", coi_date, "company_warranty_start_date");

                                                    return (
                                                        <div key={`company-warranty-${index}`} className="col-12">
                                                            <div className="card rounded-4 p-3 position-relative bg-white" style={{ outline: "1px solid #dddde0" }}>
                                                                {company_warranty.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="d-flex align-items-center justify-content-center position-absolute bg-white border border-danger text-danger"
                                                                        style={{
                                                                            top: "12px",
                                                                            right: "12px",
                                                                            width: "28px",
                                                                            minWidth: "28px",
                                                                            height: "28px",
                                                                            padding: 0,
                                                                            borderRadius: "999px",
                                                                            lineHeight: 1,
                                                                        }}
                                                                        onClick={() => this.deleteWarrantyEntry("company", index)}
                                                                    >
                                                                        <span className="icon text-14">{""}</span>
                                                                    </button>
                                                                )}
                                                                <div className="text-success fw-bold text-12 mb-3">
                                                                    {t("company_warranty_period_no")} {index + 1}
                                                                </div>
                                                                <div className="row g-3">
                                                                    {!isRenewal && (
                                                                        <div className="col-md-4">
                                                                            <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_start")}</label>
                                                                            <DatePicker
                                                                                type="th"
                                                                                className="form-control text-12"
                                                                                value={item.company_warranty_start_date || coi_date}
                                                                                disabled={!isLatest}
                                                                                onChange={(val) => this.updateWarrantyStartDateValue("company", val)}
                                                                            />
                                                                            <div className="text-primary text-12 mt-1">
                                                                                <span className="icon">{"\uf044"}</span> {t("hint_vendor_warranty_start_default")}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {isRenewal && (
                                                                        <div className="col-md-4">
                                                                            <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_date")}</label>
                                                                            <DatePicker
                                                                                type="th"
                                                                                className="form-control text-12"
                                                                                value={item.company_warranty_renew_date}
                                                                                disabled={!isLatest}
                                                                                onChange={(val) => this.updateWarrantyRenewDateValue("company", index, val)}
                                                                            />
                                                                            <div className="text-primary text-12 mt-1">
                                                                                <span className="icon">{"\uf044"}</span> {t("hint_warranty_renew_date_default")}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <div className="col-md-4">
                                                                        <label className="form-label text-secondary fw-bold text-12">
                                                                            {t("label_vendor_warranty_ext")} ({t("unit_month")})
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            min="0"
                                                                            className="form-control text-12"
                                                                            value={item.company_warranty_month}
                                                                            disabled={!isLatest}
                                                                            onChange={(e) => this.updateWarrantyMonthValue("company", index, e.target.value)}
                                                                            placeholder="0"
                                                                        />
                                                                        <div className="text-muted text-12 mt-1">
                                                                            {index === 0
                                                                                ? `${item.company_warranty_start_date ? t("calculated_from_vendor_warranty_start") : t("calculated_from_coi_date")} (${baseDate ? format_date(baseDate, "dd/mm/yyyy", "th") : "-"})`
                                                                                : `${t("continue_from_previous_period")} (${baseDate ? format_date(baseDate, "dd/mm/yyyy", "th") : "-"})`}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_end")}</label>
                                                                        <DatePicker
                                                                            type="th"
                                                                            className="form-control text-12"
                                                                            value={item.company_warranty_expire_date}
                                                                            disabled={!isLatest}
                                                                            onChange={(val) => this.updateWarrantyExpireValue("company", index, val)}
                                                                        />
                                                                        <div className="text-primary text-12 mt-1">
                                                                            <span className="icon">{""}</span> {t("hint_auto_calculate_base_plus_months")}
                                                                        </div>
                                                                    </div>
                                                                    {isRenewal && (
                                                                        <div className="col-12">
                                                                            <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_remark")}</label>
                                                                            <textarea
                                                                                className="form-control text-12"
                                                                                rows="2"
                                                                                maxLength={1000}
                                                                                value={item.company_warranty_renew_remark}
                                                                                disabled={!isLatest}
                                                                                onChange={(e) => this.updateWarrantyRenewRemarkValue("company", index, e.target.value)}
                                                                                placeholder={t("placeholder_warranty_renew_remark")}
                                                                            ></textarea>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                <div className="col-md-4">
                                                    <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_ext_count")}</label>
                                                    <input type="number" className="form-control text-12 bg-light" value={company_warranty_count} readOnly placeholder="0" />
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_remark")}</label>
                                                    <textarea
                                                        className="form-control text-12"
                                                        rows="2"
                                                        value={company_warranty_remark}
                                                        onChange={(e) => this.setState({ company_warranty_remark: e.target.value })}
                                                        placeholder={t("placeholder_vendor_warranty_remark")}
                                                    ></textarea>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {(detailCompanyWarranty.length ? detailCompanyWarranty : [{ company_warranty_month: "-", company_warranty_expire_date: "" }]).map((item, index) => (
                                                    <div key={`detail-company-warranty-${index}`} className="col-12">
                                                        <div className="card rounded-4 p-3 bg-light" style={{ outline: "1px solid #dddde0" }}>
                                                            <div className="text-success fw-bold text-12 mb-3">
                                                                {t("company_warranty_period_no")} {index + 1}
                                                            </div>
                                                            <div className="row g-3">
                                                                {index === 0 && (
                                                                    <div className="col-md-4">
                                                                        <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_start")}</label>
                                                                        <ViewBox value={item.company_warranty_start_date ? format_date(item.company_warranty_start_date, "dd/mm/yyyy", "th") : coi_date ? `${format_date(coi_date, "dd/mm/yyyy", "th")} (EOI)` : "-"} />
                                                                    </div>
                                                                )}
                                                                {index > 0 && (
                                                                    <div className="col-md-4">
                                                                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_date")}</label>
                                                                        <ViewBox value={item.company_warranty_renew_date ? format_date(item.company_warranty_renew_date, "dd/mm/yyyy", "th") : "-"} />
                                                                    </div>
                                                                )}
                                                                <div className="col-md-4">
                                                                    <label className="form-label text-secondary fw-bold text-12">
                                                                        {t("label_vendor_warranty_ext")} ({t("unit_month")})
                                                                    </label>
                                                                    <ViewBox value={item.company_warranty_month} />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_end")}</label>
                                                                    <ViewBox value={item.company_warranty_expire_date ? format_date(item.company_warranty_expire_date, "dd/mm/yyyy", "th") : "-"} />
                                                                </div>
                                                                {index > 0 && (
                                                                    <div className="col-12">
                                                                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_renew_remark")}</label>
                                                                        <ViewBox value={item.company_warranty_renew_remark || "-"} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="col-md-4">
                                                    <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_ext_count")}</label>
                                                    <ViewBox value={company_warranty_count} />
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_remark")}</label>
                                                    <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                                                        {company_warranty_remark || "-"}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-xl-3">
                                <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                                    <div className="text-secondary fw-bold text-12 mb-2">
                                        <span className="icon me-1">{""}</span> {t("asset_id")}
                                    </div>
                                    <div className="bg-primary-light text-primary fw-bold text-14 text-center py-2 rounded-3 mb-2 border border-primary">{asset_code || "-"}</div>
                                    <div className="text-success fw-bold text-12 mb-1 mt-3">
                                        <span className="icon me-1">{""}</span> {t("label_location_id")}
                                    </div>
                                    <div className="bg-success-light text-success fw-bold text-12 text-center py-2 rounded-3 border border-success">{location_running_number || "-"}</div>
                                </div>

                                <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                                        <span className="icon me-2 text-secondary">{""}</span> {t("heading_summary")}
                                    </h6>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("customer")}</span>
                                        <span className="fw-bold text-dark text-end">
                                            {data_customer?.find((e) => e.value === customer_id)?.full_name_th || "-"}
                                            <br />
                                            <span className="text-muted fw-normal text-12">{data_customer?.find((e) => e.value === customer_id)?.customer_code || ""}</span>
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("label_product_short")}</span>
                                        <span className="fw-bold text-dark text-end">{data_part?.find((e) => e.value === part_id)?.name || "-"}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("label_brand_model")}</span>
                                        <span className="fw-bold text-dark text-end">
                                            {data_part?.find((e) => e.value === part_id)?.brand?.name || ""} {data_part?.find((e) => e.value === part_id)?.modal?.name || ""}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("label_serial_no")}</span>
                                        <span className="fw-bold text-dark text-end">{serial_number || "-"}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                                        <span className="text-muted text-nowrap">
                                            <span className="icon text-danger me-1">{""}</span> {t("label_location_short")}
                                        </span>
                                        <span className="fw-bold text-primary text-end">
                                            {location_name || "-"}
                                            <br />
                                            <span className="text-muted fw-normal text-12">
                                                {location_address}
                                                {location_sub_district ? ` ต.${location_sub_district}` : ""}
                                                {location_district ? ` อ.${location_district}` : ""}
                                                {location_province ? ` จ.${location_province}` : ""} {location_zip_code}
                                            </span>
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("label_contact_short")}</span>
                                        <span className="fw-bold text-dark text-end">{contract_name || "-"}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                                        <span className="text-muted">{t("coi_date")}</span>
                                        <span className="fw-bold text-dark text-end">{coi_date ? format_date(coi_date, "dd/mm/yyyy", "th") : "-"}</span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("warranty_customer")}</span>
                                        <span className="fw-bold text-end">
                                            {latestCustomerWarrantyExpireDate ? (
                                                this.isWarrantyExpired(latestCustomerWarrantyExpireDate) ? (
                                                    <span className="text-danger">
                                                        <span className="icon me-1">{""}</span>
                                                        {format_date(latestCustomerWarrantyExpireDate, "dd/mm/yyyy", "th")}
                                                    </span>
                                                ) : (
                                                    <span className="text-success">
                                                        <span className="icon me-1">{""}</span>
                                                        {format_date(latestCustomerWarrantyExpireDate, "dd/mm/yyyy", "th")}
                                                    </span>
                                                )
                                            ) : (
                                                <span className="text-danger">-</span>
                                            )}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12">
                                        <span className="text-muted">{t("warranty_vendor")}</span>
                                        <span className="fw-bold text-end">
                                            {latestCompanyWarrantyExpireDate ? (
                                                vendorWarrantyDisplay.expired ? (
                                                    <span className="text-danger">
                                                        <span className="icon me-1">{""}</span>
                                                        {format_date(latestCompanyWarrantyExpireDate, "dd/mm/yyyy", "th")}
                                                    </span>
                                                ) : (
                                                    <span className="text-success">
                                                        <span className="icon me-1">{""}</span>
                                                        {format_date(latestCompanyWarrantyExpireDate, "dd/mm/yyyy", "th")}
                                                    </span>
                                                )
                                            ) : (
                                                <span className="text-danger">-</span>
                                            )}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                                        <span className="text-muted">{t("label_machine_price_short")}</span>
                                        <span className="fw-bold text-dark text-end">
                                            {price ? Number(price).toLocaleString() : "0"} {t("baht")}
                                        </span>
                                    </div>
                                </div>
                                <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                                    <h6 className="fw-bold text-success border-bottom pb-2 mb-3 d-flex align-items-center">
                                        <span className="icon me-2 text-success">{""}</span> {t("heading_completeness")}
                                    </h6>
                                    <div className="d-flex flex-column gap-2 text-12">
                                        <div className={customer_id ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{customer_id ? "" : ""}</span> {t("checklist_customer_info")}
                                        </div>
                                        <div className={part_id && serial_number ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{part_id && serial_number ? "" : ""}</span> {t("checklist_item_serial")}
                                        </div>
                                        <div
                                            className={
                                                location_name && location_address && location_province && location_district && location_sub_district && location_zip_code
                                                    ? "text-success"
                                                    : "text-warning"
                                            }
                                        >
                                            <span className="icon me-2">
                                                {location_name && location_address && location_province && location_district && location_sub_district && location_zip_code ? "" : ""}
                                            </span>{" "}
                                            {t("checklist_location")}
                                        </div>
                                        <div className={invoice_number && invoice_date ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{invoice_number && invoice_date ? "" : ""}</span> {t("checklist_invoice")}
                                        </div>
                                        <div className={coi_date ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{coi_date ? "" : ""}</span> {t("checklist_coi_date")}
                                        </div>
                                        <div className={customer_warranty_count > 0 && isLatestCustomerWarrantyComplete ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{customer_warranty_count > 0 && isLatestCustomerWarrantyComplete ? "" : ""}</span> {t("checklist_customer_warranty")}
                                        </div>
                                        <div className={company_warranty_count > 0 && isLatestCompanyWarrantyComplete ? "text-success" : "text-warning"}>
                                            <span className="icon me-2">{company_warranty_count > 0 && isLatestCompanyWarrantyComplete ? "" : ""}</span> {t("checklist_vendor_warranty")}
                                        </div>
                                    </div>
                                </div>

                                <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                                        <span className="icon me-2 text-secondary">{"\uf303"}</span> {t("heading_record_edit_info")}
                                    </h6>
                                    <div className="mb-2 text-12">
                                        <div className="fw-bold text-dark">{t("label_record_asset")}</div>
                                        <div className="text-muted">{this.formatUserActivity(created_by, created_at)}</div>
                                    </div>
                                    <div className="text-12">
                                        <div className="fw-bold text-dark">{t("label_edit_asset_info")}</div>
                                        <div className="text-muted">{this.formatUserActivity(updated_by, updated_at)}</div>
                                    </div>
                                </div>

                                <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                                        <span className="icon me-2 text-secondary">{""}</span> {t("label_tags_section")}
                                    </h6>
                                    <div className="d-flex flex-wrap gap-2 mb-2">
                                        {tags && tags.length > 0 ? (
                                            tags.map((tag, i) => (
                                                <span key={i} className="badge bg-primary-light text-primary border border-primary fw-normal py-1 px-2 text-12">
                                                    {tag}
                                                </span>
                                            ))
                                        ) : (
                                            <span className="text-muted text-12">{t("label_no_tags")}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer px-4 py-3 bg-white border-top d-flex justify-content-between align-items-center w-100 mt-auto">
                        <div className="text-warning text-12 fw-bold d-flex align-items-center">
                            <span className="icon me-2">{""}</span>
                            {modal_edit_mode ? t("note_footer_edit_vendor_warranty_only") : t("note_footer_view_only_edit_hint")}
                        </div>
                        <div className="d-flex gap-2">
                            <button type="button" className="btn btn-white border fw-bold px-4 text-secondary bg-white shadow-sm" onClick={() => this.closeModalWithAnimation("modal_view")}>
                                <span className="icon me-1">{""}</span> {modal_edit_mode ? t("cancel") : t("close")}
                            </button>
                            {modal_edit_mode && can("warehouse-asset.update") && (
                                <button type="button" className="btn btn-primary fw-bold px-4 d-flex align-items-center shadow-sm" onClick={this.SaveVendorWarranty}>
                                    <span className="icon me-2">{""}</span> {t("save")}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  };


  render() {
    const { data, data_all, count, filter_search, filter_customer, filter_status, filter_vendor_warranty, data_customer, modal_map, currentPath } = this.state;

    // ใช้ data_all (ดึงแบบไม่แบ่งหน้า) ในการนับ KPI ให้ครบทุกรายการที่ตรงกับ filter ปัจจุบัน ไม่ใช่แค่หน้าที่กำลังแสดง
    const activeCount = (data_all || []).filter((e) => e.is_active).length;
    // หมดประกัน = ไม่มีรอบประกันไหนครอบวันนี้ (รวมช่วงว่างก่อนถึงวันเริ่มรอบที่ต่อใหม่) - utils/warranty.js
    const customerWarrantyExpiringCount = (data_all || []).filter((item) => resolveWarrantyStatus(item, "customer").expired).length;
    const vendorWarrantyExpiringCount = (data_all || []).filter((item) => resolveWarrantyStatus(item, "company").expired).length;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("asset_management")}</h3>
              <div className="text-secondary text-14">{t("subtitle_warehouse_asset_management")}</div>
            </div>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded bg-light text-secondary d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                  <div><h4 className="fw-bold text-dark mb-0">{count}</h4><div className="text-secondary text-12">{t("total_assets")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                  <div><h4 className="fw-bold text-success mb-0">{activeCount}</h4><div className="text-secondary text-12">{t("active")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                  <div><h4 className="fw-bold text-danger mb-0">{customerWarrantyExpiringCount}</h4><div className="text-secondary text-12">{t("customer_warranty_expiring")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{""}</div>
                  <div><h4 className="fw-bold text-danger mb-0">{vendorWarrantyExpiringCount}</h4><div className="text-secondary text-12">{t("vendor_warranty_expiring")}</div></div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex gap-2 flex-wrap">
                <div className="position-relative flex-grow-1" style={{ maxWidth: "250px" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-250"
                    style={{ height: "38px" }}
                    placeholder={t("search_assets")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                  />
                </div>
                <Select className="form-control wpx-180" options={data_customer} value={filter_customer} onChange={(e) => this.setState({ filter_customer: e })} placeholder={t("select_customer")} />
                <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                  <option value="">{t("all_status")}</option>
                  <option value="true">{t("active")}</option>
                  <option value="false">{t("inactive")}</option>
                </select>
                <select className="form-select wpx-200" value={filter_vendor_warranty} onChange={(e) => this.setState({ filter_vendor_warranty: e.target.value })}>
                  <option value="">{t("all_vendor_warranty")}</option>
                  <option value="false">{t("no_vendor_warranty")}</option>
                  <option value="true">{t("has_vendor_warranty")}</option>
                </select>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>{t("filter")}</button>
                  <button
                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                    onClick={() => this.setState({ filter_search: "", filter_status: "", filter_customer: "", filter_vendor_warranty: "false" }, () => this.Get(1))}
                  >
                    {t("clear_all")}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm pb-2">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1900px" }}>
                <thead>
                  <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                    <th className="py-3 border-0">{t("asset_id")}</th>
                    <th className="py-3 border-0">{t("product_name")}</th>
                    <th className="py-3 border-0">{t("customer")}</th>
                    <th className="py-3 border-0">{t("category_1")}</th>
                    <th className="py-3 border-0">{t("brand_model_1_header")}</th>
                    <th className="py-3 border-0">{t("serial_no")}</th>
                    <th className="py-3 border-0">{t("invoice_no")}</th>
                    <th className="py-3 border-0">{t("eoi_date")}</th>
                    <th className="py-3 border-0">{t("warranty_customer")}</th>
                    <th className="py-3 border-0">{t("warranty_vendor")}</th>
                    <th className="py-3 border-0 text-center">{t("status")}</th>
                    <th className="py-3 border-0 wpx-90 text-center bg-white" style={STICKY_ACTION_STYLE}>{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr><td colSpan="12" className="text-center py-4 text-secondary">{t("no_data_found")}</td></tr>
                  ) : (
                    data.map((item, idx) => {
                      // สถานะประกันดูเป็นรายรอบ (วันเริ่ม <= วันนี้ <= วันหมด) - utils/warranty.js
                      const customerWarranty = resolveWarrantyStatus(item, "customer");
                      const companyWarranty = resolveWarrantyStatus(item, "company");
                      const latestCustomerWarrantyExpireDate = customerWarranty.expireDate;
                      // คอลัมน์ประกันผู้จำหน่ายแสดงวันหมดของรอบล่าสุดเสมอ ส่วนไอคอน ✓/✗ ยังตัดสินตามวันนี้
                      const latestCompanyWarrantyExpireDate = getLatestWarrantyExpireDate(item, "company");
                      const isCustomerWarrantyExpired = customerWarranty.expired;
                      const isCompanyWarrantyExpired = companyWarranty.expired;
                      return (
                        <tr key={idx} className="border-bottom border-light bg-white">
                          <td className="text-nowrap"><span className="fw-bold text-primary text-12 pointer hover-underline" onClick={() => this.openModalDetail(item)}>{item.asset_code || "-"}</span></td>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <div className="wpx-30 hpx-30 rounded bg-light d-flex align-items-center justify-content-center me-2 text-secondary"><span className="icon text-12">{""}</span></div>
                              <div><div className="fw-bold text-dark text-12">{item.part?.name || "-"}</div></div>
                            </div>
                          </td>
                          <td className="text-nowrap">
                            <div className="text-dark fw-bold text-12">{item.customer?.full_name_th || "-"}</div>
                            <div className="text-secondary text-12">{item.customer?.customer_code || ""}</div>
                          </td>
                          <td className="text-nowrap"><span className="text-primary text-12">{item.part?.part_category?.name || "-"}</span></td>
                          <td className="text-nowrap">
                            <div className="text-dark fw-bold text-12">{item.part?.brand?.name || "-"}</div>
                            <div className="text-secondary text-12">{item.part?.model?.name || ""}</div>
                          </td>
                          <td className="text-nowrap"><span className="text-dark text-12">{item.serial_number || "-"}</span></td>
                          <td className="text-nowrap"><span className="text-dark text-12">{item.invoice_number || "-"}</span></td>
                          <td className="text-nowrap"><span className="text-dark text-12">{item.coi_date ? format_date(item.coi_date.split("T")[0], "dd/mm/yyyy", "th") : "-"}</span></td>
                          <td className="text-nowrap">
                            <span className={`text-12 fw-bold ${!isCustomerWarrantyExpired ? "text-success" : "text-danger"}`}>
                              {latestCustomerWarrantyExpireDate ? (
                                <><span className="icon me-1">{isCustomerWarrantyExpired ? "\uf00d" : "\uf00c"}</span>{format_date(latestCustomerWarrantyExpireDate.split("T")[0], "dd/mm/yyyy", "th")}</>
                              ) : (<span className="icon me-1">-</span>)}
                            </span>
                          </td>
                          <td className="text-nowrap">
                            <span className={`text-12 fw-bold ${!isCompanyWarrantyExpired ? "text-success" : "text-danger"}`}>
                              {latestCompanyWarrantyExpireDate ? (
                                <><span className="icon me-1">{isCompanyWarrantyExpired ? "\uf00d" : "\uf00c"}</span>{format_date(latestCompanyWarrantyExpireDate.split("T")[0], "dd/mm/yyyy", "th")}</>
                              ) : (<span className="icon me-1">-</span>)}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className={`badge bg-${item.is_active ? "success" : "secondary"}-light text-${item.is_active ? "success" : "secondary"} rounded-pill px-2 py-1 fw-bold text-12`}>
                              {item.is_active ? `● ${t("active")}` : `● ${t("inactive")}`}
                            </span>
                          </td>
                          <td className="rounded-end text-center bg-white" style={STICKY_ACTION_STYLE}>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <ActionIconButton
                                label={t("view")}
                                icon={ACTION_ICONS.view}
                                variant="primary"
                                onClick={() => this.openModalDetail(item, false)}
                              />
                              {can("warehouse-asset.update") && (
                              <ActionIconButton
                                label={t("edit")}
                                icon={ACTION_ICONS.edit}
                                variant="warning"
                                onClick={() => this.openModalDetail(item, true)}
                              />
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center p-3 text-secondary text-12 bg-white border-top">
              <div>{t("showing")} 1-{data.length} {t("of")} {count} {t("assets")}</div>
              <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
            </div>
          </div>
        </div>

        {this.renderDetailModal()}

        {/* Modal แผนที่แบบดูอย่างเดียว */}
        <style>{`.asset-map-modal-backdrop { z-index: 1055 !important; }`}</style>
        <Modal show={modal_map} onHide={() => this.setState({ modal_map: false })} size={"fullscreen"} style={{ zIndex: 1060 }} backdropClassName="asset-map-modal-backdrop">
          <Modal.Header className="border-0 pb-2" closeButton>
            <h5 className="fw-bold mb-0">{t("label_pin_from_map")}</h5>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div className="position-relative" style={{ height: "80vh" }}>
              <LoadScript googleMapsApiKey={process.env.REACT_APP_API_MAP_KEY} libraries={["geometry"]}>
                <GoogleMap
                  mapContainerStyle={{ height: "100%", width: "100%" }}
                  center={currentPath || { lat: 18.9076, lng: 99.046 }}
                  zoom={10}
                  options={{
                    disableDefaultUI: true,
                    clickableIcons: false,
                    disableDoubleClickZoom: true,
                    gestureHandling: "greedy",
                  }}
                >
                  {currentPath && <Marker position={currentPath} />}
                </GoogleMap>
              </LoadScript>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-2 border-0 d-flex justify-content-between">
            <div className="d-flex flex-wrap">
              <span className="me-2">Latitude: {currentPath?.lat || "-"},</span>
              <span>Longitude: {currentPath?.lng || "-"}</span>
            </div>
            <button className="btn btn-outline-secondary px-5" onClick={() => this.setState({ modal_map: false })}>
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
